import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RepairHistoryService } from '@app/repairs/services/repair-history.service';
import moment from 'moment';
import { DataService } from '@app/core/services/data.service';
import { OrderByPipe } from '@app/shared/pipes/orderby.pipe';
import { LimitToPipe } from '@app/shared/pipes/limitto.pipe';
import { FutureDatesPipe } from '@app/shared/pipes/futuredates.pipe';
import { PreviousDatesPipe } from '@app/shared/pipes/previousdates.pipe';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';
import { dictionaryItems } from '@app/core/constants/dictionaryItems';
import { Adb2cService } from '@app/blocks/adb2c/services/adb2c/adb2c.service';
import { Subject } from 'rxjs/internal/Subject';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
    selector: 'app-repair-history',
    imports: [ CommonModule, OrderByPipe, LimitToPipe, FutureDatesPipe, PreviousDatesPipe, SpinnerComponent ],
    templateUrl: './repair-history.component.html',
    styleUrl: './repair-history.component.scss',
})
export class RepairHistoryComponent implements OnInit, OnDestroy {


    config: any = {};
    repairHistoryData: any
    dictionaryItems: any
    loading: boolean = true;
    showNoRepairsFound: boolean = false;
    defaultMaxRepairs: number = 30
    private destroy$ = new Subject<void>();
    private userSubscription?: Subscription;

    constructor(private repairHistoryService: RepairHistoryService,
        private dataService: DataService,
        private adb2cService: Adb2cService) {

        // Default Values //
        this.config.defaultMaxRepairs = 30;
        this.config.filterFromDate = moment().subtract(8, 'weeks');
        this.config.filterToDate = moment();
        this.config.filterCustomFrom = this.config.filterFromDate.toDate();
        this.config.filterCustomTo = this.config.filterToDate.toDate();
        this.config.showPaymentsFromText = dictionaryItems.showPaymentsFrom;
        this.config.customText = dictionaryItems.custom;
        this.config.daysText = dictionaryItems.days;
        this.config.toText = dictionaryItems.to;
        this.config.fromText = dictionaryItems.from;
        this.config.filterText = dictionaryItems.filter;
    }


    ngOnInit() {
        this.loading = true;

        this.adb2cService.getUser();
        this.userSubscription = this.adb2cService.activeUser.asObservable().subscribe((user: any) => {
            console.log(user);
            if (user && user[ 'tenancy_reference' ]) {
                this.repairHistoryService.getRepairHistory(user[ 'tenancy_reference' ]!, this.config.filterFromDate.format('YYYY[%2F]MM[%2F]DD'), this.config.filterToDate.format('YYYY[%2F]MM[%2F]DD')).subscribe({
                    next: (response) => {
                        console.log(response);
                        this.repairHistoryData = response.repairs.slice(0, this.config.defaultMaxRepairs);
                        console.log(this.repairHistoryData);
                        this.showNoRepairsFound = false;
                    },
                    error: (error) => {
                        console.error(error)
                        this.showNoRepairsFound = true;
                    },
                    complete: () => {
                        this.loading = false;
                    }
                });
            }
        })
    }

    onChangeFromDate(event: any) {
        this.config.filterCustomFrom = moment(event.target.valueAsDate);
    }

    onChangeToDate(event: any) {
        this.config.filterCustomTo = moment(event.target.valueAsDate);
    }

    filter(value: number) {

        this.loading = true;
        this.showNoRepairsFound = false;
        if (value) {
            this.config.filterFromDate = moment().subtract(value, "days");
            this.config.filterToDate = moment();
            this.config.filterCustom = false;
        } else {
            this.config.filterFromDate = moment(this.config.filterCustomFrom)
            this.config.filterToDate = moment(this.config.filterCustomTo);
        }

        this.userSubscription = this.adb2cService.activeUser.asObservable().subscribe((user: any) => {
            if (user[ 'tenancy_reference' ]) {
                this.repairHistoryService.getRepairHistory(user[ 'tenancy_reference' ]!, this.config.filterFromDate.format('YYYY[%2F]MM[%2F]DD'), this.config.filterToDate.format('YYYY[%2F]MM[%2F]DD')).subscribe({
                    next: (response) => {
                        if (response && response.repairs && (response.repairs.length > 0)) {
                            this.repairHistoryData = response.repairs.slice(0, this.config.defaultMaxRepairs);
                            console.log(this.repairHistoryData);
                            this.showNoRepairsFound = false;
                        }
                        else {
                            this.repairHistoryData = [];
                            this.showNoRepairsFound = true;
                        }
                    },
                    error: (error) => {
                        console.error(error)
                        this.repairHistoryData = [];
                        this.showNoRepairsFound = true;
                    },
                    complete: () => {
                        this.loading = false;
                    }
                });
            }

        });
    }

    showCustomfilter() {
        this.showNoRepairsFound = false;
        this.config.filterCustom = true;
        this.repairHistoryData = [];
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();

        this.userSubscription?.unsubscribe();
    }
}

